"use strict";

const InputBaseControlActionComponent = require('@gluenetworks/input_base_control').Action;
const Renderer = require("./ButtonControlRenderer");

class ButtonControlComponent extends InputBaseControlActionComponent {

    /**
     * @schema.name Button Control
     * @schema.package @gluenetworks/button_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Action.Button
     * @schema.events ["Disabled", "Value", "Visible", "Invalid", "Active", "Label", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserClick", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.label.example "Button Text"
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._title = configOptions.title ? configOptions.title : undefined;
        this._class = configOptions.class ? configOptions.class : undefined;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        let prom = new Promise((resolve) => {
            if (this._renderer) {
                this._renderer._shutdown()
                  .then((result) => {
                      resolve(result)
                  });
            } else {
                resolve();
            }
        });
        this._renderer = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._active = undefined;
        this._darkTheme = undefined;
        this._theme = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/


    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ButtonControlComponent;
